import { mode, cssVar } from "@chakra-ui/theme-tools";

const $startColor = cssVar("skeleton-start-color");
const $endColor = cssVar("skeleton-end-color");

const baseStyle = (props) => {
  const StartColor = mode("#EDF2F7", "#1A202C")(props);
  const EndColor = mode("#A0AEC0", "#4A5568")(props);

  return {
    [$startColor.variable]: StartColor,
    [$endColor.variable]: EndColor,
    opacity: 0.7,
    borderRadius: "2px",
    borderColor: StartColor,
    background: EndColor
  };
};

export default {
  baseStyle
};
